import * as React from 'react';
import { translation, currencyFormatter, numberFormatter } from 'easit--localization';

export interface ITicketBetsProps {
    bets: ITicketBets[];
}

export interface IBetCombination {
    name: string;
    rate: number;
    stake: number;
    potentialWin: number;
}

export interface ITicketBets {
    combinationCount: number;
    potentialWinMin: number;
    potentialWinMax: number;
    selectedSystem: number;
    systemStake: number;
    unitStake: number;
    selectionCount: number;
    systemOutOf: number;
    combinations: IBetCombination[];
}

export const TicketBets = (props: ITicketBetsProps) => {
    const [selectedBetIdx, setSelectedBetIdx] = React.useState(-1);

    return props.bets && props.bets.length
        ? <table className="w-100 tip-list ticket-bet-list">
            <thead>
                <tr>
                    <th>{translation().bet_System}</th>
                    <th>{translation().bet_Stake}</th>
                    <th>{translation().bet_Sum}</th>
                    <th>{translation().bet_PossibleWinFrom}</th>
                    <th>{translation().bet_PossibleWinTo}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {
                    props.bets.map((bet, idx) => <React.Fragment key={idx}>
                        <tr onClick={() => { setSelectedBetIdx(selectedBetIdx === idx ? -1 : idx) }} className="bet-row">
                            <td>{`${bet.selectedSystem}/${bet.systemOutOf} (${bet.combinationCount} komb.)`}</td>
                            <td>{currencyFormatter.format(bet.unitStake)}</td>
                            <td>{currencyFormatter.format(bet.systemStake)}</td>
                            <td>{currencyFormatter.format(bet.potentialWinMin)}</td>
                            <td>{currencyFormatter.format(bet.potentialWinMax)}</td>
                            <td>
                                <span className={`fa toogle-icon ${selectedBetIdx === idx ? 'fa-angle-down' : 'fa-angle-left'}`}></span>
                            </td>
                        </tr>
                        {
                            selectedBetIdx === idx &&
                            <tr>
                                <td colSpan={6}>
                                    <table className="w-100 tip-list ticket-bet-list">
                                        <thead>
                                            <tr>
                                                <th className="text-center">{translation().coupon_TicketListCombination}</th>
                                                <th className="text-right">{translation().coupon_TicketListRate}</th>
                                                <th className="text-right">{translation().coupon_TicketListStake}</th>
                                                <th className="text-right">{translation().coupon_TicketListPotentialWin}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                bet.combinations.map((item, idx) => <tr key={idx}>
                                                    <td className="text-center">{item.name}</td>
                                                    <td className="text-right">{numberFormatter.format(item.rate)}</td>
                                                    <td className="text-right">{currencyFormatter.format(item.stake)}</td>
                                                    <td className="text-right">{currencyFormatter.format(item.potentialWin)}</td>
                                                </tr>)
                                            }
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        }
                    </React.Fragment>
                    )
                }
            </tbody>
        </table>
        : null
}